module.exports = __webpack_public_path__ + "static/media/icon_info-circle.10f50aa4.svg";